import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { actionResetGetConfigPtMonAnalogico } from '../get-monitoramento/slices'
import { deleteConfigPtMonAnalogico } from './services'

const initialState: any = {
  status: "",
  data: []
}

export const actionDeleteConfigPtMonAnalogico: any = createAsyncThunk<any, any>(
  "ACTION_DELETE_CONFIG_PT_MON_ANALOGICO",
  async (_, { getState }: any) => {
    const {
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
          },
          entrada
        }
      },
    } = getState()

    return deleteConfigPtMonAnalogico({
      idCentral,
      adrModulo,
      idEntrada: entrada.id,
    })
  }
)

const sliceDeleteConfigPtMonAnalogico = createSlice({
  name: "DELETE_CONFIG",
  initialState,
  reducers: {
    actionResetDeleteConfigPtMonAnalogico: (state) => {
      state.status = ""
    }
  },
  extraReducers: {
    [actionDeleteConfigPtMonAnalogico.pending]: (state) => {
      state.status = "loading"
    },
    [actionDeleteConfigPtMonAnalogico.fulfilled]: (state, {payload}) => {
      state.status = "success"
      state.data = payload
    },
    [actionDeleteConfigPtMonAnalogico.rejected]: (state, err) => {
      console.log(err)
      state.status = "error"
    },
  }
})

export default sliceDeleteConfigPtMonAnalogico.reducer
export const { actionResetDeleteConfigPtMonAnalogico } = sliceDeleteConfigPtMonAnalogico.actions